export type ImageProperties = {
  width?: number;
  height?: number;
};

export const extractImageDimensions = async (data: Blob): Promise<ImageProperties> => {
  let width, height;

  try {
    const image = await createImageBitmap(data);
    ({ width, height } = image);
    image.close();
  } catch (error) {
    console.warn("Failed to extract image dimensions on upload", error);
  }

  return { width, height };
};
